import styles from './RmInvestigationOverlay.module.scss';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    selectRmInvestigationSelected,
    selectRmValue,
    selectShowRmInvestigationOverlay,
    selectTimeslicerEndMonth,
    selectTimeslicerStartMonth
} from 'selectors/selectors';
import { toggleRmInvestigationOverlay } from 'slices/AppSlice';
import { submitRmInvestigation } from 'slices/RmSlice';

const RmInvestigationOverlay = () => {
    const dispatch = useDispatch();
    const shouldShowOverlay = useSelector(selectShowRmInvestigationOverlay);
    const rmValue = useSelector(selectRmValue);
    const tsStart = useSelector(selectTimeslicerStartMonth);
    const tsEnd = useSelector(selectTimeslicerEndMonth);
    const rmInvestigationSelected = useSelector(selectRmInvestigationSelected);

    const handleDisableScrolling = (event) => event.preventDefault();
    const disableScrolling = () => {
        window.addEventListener('wheel', handleDisableScrolling, {
            passive: false
        });
    };

    const enableScrolling = () => {
        window.removeEventListener('wheel', handleDisableScrolling);
    };

    useEffect(() => {
        if (shouldShowOverlay) {
            disableScrolling();
        }

        return () => {
            enableScrolling();
        };
    }, [shouldShowOverlay]);

    const handleButtonClick = (buttonClicked) => {
        if (buttonClicked === 'yes') {
            dispatch(
                submitRmInvestigation({
                    query: {
                        rm: rmValue,
                        start: tsStart.epoch,
                        end: tsEnd.epoch
                    },
                    postRequestPayload: rmInvestigationSelected
                })
            );
        }
        dispatch(toggleRmInvestigationOverlay());
    };

    return (
        shouldShowOverlay && (
            <div className={styles.wrapper}>
                <div className={styles.modal}>
                    <div className={styles.leftContainer}>
                        <p className={styles.topText}>Confirm the changes?</p>
                        <p className={styles.bottomText}>
                            The changes will affect the algorithm
                        </p>
                    </div>
                    <div className={styles.rightContainer}>
                        <button
                            className={styles.button}
                            onClick={() => handleButtonClick('yes')}
                        >
                            Yes
                        </button>
                        <button
                            className={styles.button}
                            onClick={() => handleButtonClick('no')}
                        >
                            No
                        </button>
                    </div>
                </div>
            </div>
        )
    );
};

export default RmInvestigationOverlay;
